import React, { useRef } from "react";
import { Parallax } from "react-parallax";
import { phoneNumber } from "../config/commonConfig";

function Subscribe() {
  const form = useRef();
  const [message, setMessage] = React.useState("");
  const sendMessage = (e) => {
    e.preventDefault();
    window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`, '_blank');
    form.current.reset();
  };

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  return (
    <section className="hero-wrap ">
      <div className="hero-mask opacity-9 bg-primary" />

      <Parallax
        bgImage="images/intro-bg-3.jpg"
        bgImageAlt="Intro"
        strength={200}
      >
        <div className="hero-content section">
          <div className="container">
            <div className="justify-content-center text-center">
              <h2 className="text-9 fw-600 text-white text-center mb-3">
                Está pronto para faturar?
              </h2>
              <hr className="heading-separator-line bg-white opacity-10 mx-auto" />
              <p className="lead text-center text-white mb-4">
                Digite sua mensagem e envie no WhatsApp para começar seu plano de negócio!
              </p>
              <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 col-xl-5">
                  {/* Subscribe Form */}
                  <form id="contact-form" ref={form} onSubmit={sendMessage}>
                    <div className="mb-3">
                      <input
                        id="message"
                        name="message"
                        type="text"
                        className="form-control border-2"
                        required
                        placeholder="Digite sua mensagem..."
                        onChange={handleChange}
                      />
                    </div>
                    <button
                      id="submit-btn"
                      className="btn text-white text-uppercase shadow fw-600"
                      type="submit"
                      style={{ cursor: "pointer", textDecoration: "none", backgroundColor: '#33D621', background: 'linear-gradient(180deg,rgba(51, 214, 33, 1) 0%, rgba(38, 162, 25, 1) 100%)' }}
                    >
                      Enviar Whatsapp
                    </button>
                  </form>
                  {/* Subscribe Form End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Parallax>
    </section>
  );
}

export default Subscribe;
